import React from 'react';
import { CircularProgress } from '@mui/material';
import { CustomBackdrop } from './style';

const CustomLoader = () => (
  <CustomBackdrop
    open
    sx={{ zIndex: 1000 }}
  >
    <CircularProgress />
  </CustomBackdrop>
);

export default CustomLoader;
